import axios from "axios";

import buildPaginationQueryOpts from "@/shared/sort/sorts";

import { IModel3d } from "@/shared/model/model-3-d.model";

const baseApiUrl = 'api/model-3-ds';
const baseApiMobileUrl = 'api/mobile/model-3-ds';

export default class Model3dService {
  public find(id: number): Promise<IModel3d> {
    return new Promise<IModel3d>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findByAccessToken(id: number, accessToken: string): Promise<IModel3d> {
    return new Promise<IModel3d>((resolve, reject) => {
      axios
        .get(`${baseApiMobileUrl}/${id}`, {
          headers: {
            Authorization: accessToken,
          },
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IModel3d): Promise<IModel3d> {
    return new Promise<IModel3d>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IModel3d): Promise<IModel3d> {
    return new Promise<IModel3d>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IModel3d): Promise<IModel3d> {
    return new Promise<IModel3d>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public filter(paginationQuery?: any, filter?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/filter?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
